export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <span className="text-xl font-bold font-heading text-white">黑料网站</span>
            <p className="mt-4 text-sm text-white/50 leading-relaxed">
              黑料网站是一个专注于网红娱乐圈黑料聚合与导航的平台。
              我们汇集吃瓜黑料网站、51黑料网站、91黑料网站及网红黑料网站推荐合集，
              为用户提供最新最全的黑料网站大全与实时热门爆料索引。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500/40 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-white/80"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500/40 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-white/80"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-white/10 hover:bg-primary-500/40 transition-colors cursor-pointer">
                <i className="ri-telegram-line text-white/80"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">快速导航</h3>
            <ul className="space-y-2.5">
              {[
                { label: '热门话题', href: '#topics' },
                { label: '吃瓜热评', href: '#comments' },
                { label: '黑料榜单', href: '#ranking' },
                { label: '最新快讯', href: '#updates' },
                { label: '黑料索引', href: '#index' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-white/50 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">热门分类</h3>
            <ul className="space-y-2.5">
              {[
                { label: '吃瓜黑料网站', href: '#topics' },
                { label: '51黑料网站', href: '#topics' },
                { label: '91黑料网站', href: '#topics' },
                { label: '网红黑料网站', href: '#topics' },
                { label: '最新黑料网站', href: '#updates' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => {
                      e.preventDefault();
                      document.querySelector(item.href)?.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-sm text-white/50 hover:text-primary-300 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-white mb-4">合作伙伴</h3>
            <p className="text-sm text-white/40 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} 黑料网站 - 吃瓜黑料网站、51黑料网站及91黑料网站实时热门爆料 | 网红黑料网站推荐合集与最新黑料网站大全
          </p>
          <p className="text-xs text-white/40">
            本站为导航聚合平台，内容来源均为第三方公开信息
          </p>
        </div>
      </div>
    </footer>
  );
}